import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SummarizeIcon from '@mui/icons-material/Summarize';
import InsightsIcon from '@mui/icons-material/Insights';
import RefreshIcon from '@mui/icons-material/Refresh';
import CRMLogo from '../assets/crmimg.png';
import { URL } from '../config';
 
function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}
 
const extractArray = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.result)) return res.result;
  if (Array.isArray(res?.results)) return res.results;
  if (Array.isArray(res?.enquiries)) return res.enquiries;
  if (Array.isArray(res?.followups)) return res.followups;
  if (Array.isArray(res?.records)) return res.records;
  const firstArr = Object.values(res || {}).find(v => Array.isArray(v));
  if (firstArr) return firstArr;
  return [];
};
 
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
 
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
 
  .dash-root {
    font-family: 'Poppins', sans-serif;
    background: #F4F6FA;
    min-height: 100vh;
    padding: 28px 24px;
  }
 
  .dash-inner { max-width: 1200px; margin: 0 auto; }
 
  .dash-header {
    display: flex; align-items: center; gap: 16px;
    background: #FFFFFF; border: 1px solid #E8ECF4;
    border-radius: 16px; padding: 20px 24px; margin-bottom: 32px;
    box-shadow: 0 1px 3px rgba(15,23,42,0.06), 0 4px 16px rgba(15,23,42,0.04);
    position: relative; overflow: hidden;
  }
  .dash-header::before {
    content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px;
    background: linear-gradient(180deg, #2563EB 0%, #7C3AED 100%);
    border-radius: 16px 0 0 16px;
  }
  .dash-logo-wrap {
    width: 52px; height: 52px; border-radius: 12px;
    background: #EEF2FF; border: 1px solid #C7D2FE;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .dash-logo-wrap img { width: 32px; height: 32px; object-fit: contain; }
  .dash-header-text { flex: 1; }
  .dash-header-eyebrow {
    font-size: 10px; font-weight: 600; letter-spacing: 2px;
    color: #2563EB; text-transform: uppercase; margin-bottom: 3px;
  }
  .dash-header-greeting { font-size: 20px; font-weight: 800; color: #0F172A; line-height: 1.25; }
  .dash-header-sub { font-size: 12px; color: #080a0c; margin-top: 2px; font-weight: 500; }
  .dash-header-meta { display: flex; align-items: center; gap: 10px; }
  .dash-date-pill {
    font-size: 11px; font-weight: 600; color: #080a0c;
    background: #F1F5F9; border: 1px solid #E2E8F0;
    border-radius: 8px; padding: 6px 12px; white-space: nowrap;
  }
  .dash-refresh-btn {
    width: 36px; height: 36px; border-radius: 8px;
    background: #F8FAFC; border: 1px solid #E2E8F0; color: #080a0c;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all 0.18s ease; flex-shrink: 0;
  }
  .dash-refresh-btn:hover { background: #EFF6FF; border-color: #BFDBFE; color: #2563EB; }
  .dash-refresh-btn.spinning svg { animation: spin 0.7s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
 
  .dash-section-wrap { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
  .dash-section-label {
    font-size: 11px; font-weight: 700; letter-spacing: 1.8px;
    color: #020407; text-transform: uppercase; white-space: nowrap;
  }
  .dash-section-line { flex: 1; height: 1px; background: #E2E8F0; }
 
  .dash-4grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 28px;
  }
  @media (max-width: 960px) { .dash-4grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 520px) {
    .dash-4grid { grid-template-columns: 1fr; }
    .dash-root { padding: 16px 14px; }
    .dash-date-pill { display: none; }
    .dash-header-greeting { font-size: 17px; }
  }
 
  .u-card {
    background: #FFFFFF;
    border: 1px solid #E8ECF4;
    border-radius: 16px;
    padding: 20px 18px 18px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(15,23,42,0.05), 0 3px 10px rgba(15,23,42,0.04);
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }
  .u-card::after {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
    background: linear-gradient(90deg, var(--uc), var(--uc2));
    border-radius: 16px 16px 0 0;
  }
  .u-card:hover {
    transform: translateY(-5px);
    border-color: color-mix(in srgb, var(--uc) 28%, #E8ECF4);
    box-shadow: 0 12px 32px color-mix(in srgb, var(--uc) 15%, transparent), 0 2px 8px rgba(15,23,42,0.07);
  }
  .u-card-top {
    display: flex; align-items: flex-start;
    justify-content: space-between; margin-bottom: 14px;
  }
  .u-icon-wrap {
    width: 48px; height: 48px; border-radius: 13px;
    background: var(--uc-bg); color: var(--uc);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0; position: relative;
  }
  .u-icon-wrap::after {
    content: ''; position: absolute; inset: -1px; border-radius: 14px;
    border: 1.5px solid color-mix(in srgb, var(--uc) 20%, transparent);
  }
  .u-badge {
    display: inline-flex; align-items: center; gap: 5px;
    background: color-mix(in srgb, var(--uc) 10%, transparent);
    border: 1px solid color-mix(in srgb, var(--uc) 18%, transparent);
    border-radius: 20px; padding: 4px 10px;
    font-size: 10px; font-weight: 700; color: var(--uc); letter-spacing: 0.4px;
  }
  .u-badge-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--uc); }
 
  .u-count {
    font-size: 34px; font-weight: 800; color: #0F172A;
    letter-spacing: -1px; line-height: 1;
    margin-bottom: 4px; min-height: 34px;
    display: flex; align-items: center;
  }
  .u-skeleton {
    width: 64px; height: 34px;
    background: linear-gradient(90deg, #F1F5F9 25%, #E2E8F0 50%, #F1F5F9 75%);
    background-size: 200% 100%;
    animation: shimmer 1.3s infinite; border-radius: 8px;
  }
  @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
 
  .u-label { font-size: 13px; font-weight: 700; color: #0F172A; letter-spacing: 0.1px; margin-bottom: 4px; }
  .u-desc { font-size: 11px; color: #000203; font-weight: 500; line-height: 1.5; flex: 1; margin-bottom: 0; }
  .u-divider { height: 1px; background: #F1F5F9; margin: 14px 0 12px; }
 
  .u-my-pill {
    display: inline-flex; align-items: center; gap: 6px;
    border-radius: 7px; padding: 4px 10px;
    font-size: 10px; font-weight: 700;
    margin-top: 7px; width: fit-content;
  }
  .u-my-pill-dot { width: 5px; height: 5px; border-radius: 50%; flex-shrink: 0; }
  .u-my-pill-blue   { background: #EFF6FF; border: 1px solid #BFDBFE; color: #2563EB; }
  .u-my-pill-blue   .u-my-pill-dot { background: #2563EB; }
  .u-my-pill-orange { background: #FFF7ED; border: 1px solid #FED7AA; color: #EA580C; }
  .u-my-pill-orange .u-my-pill-dot { background: #EA580C; }
 
  .u-sub-row { display: flex; gap: 7px; flex-wrap: wrap; }
  .u-sub-btn {
    display: flex; align-items: center; gap: 5px;
    background: var(--uc-bg);
    border: 1px solid color-mix(in srgb, var(--uc) 22%, transparent);
    border-radius: 7px; padding: 5px 10px;
    font-size: 10px; font-weight: 600; color: var(--uc);
    cursor: pointer; transition: background 0.15s, border-color 0.15s, transform 0.12s;
    white-space: nowrap; font-family: 'Poppins', sans-serif;
  }
  .u-sub-btn:hover {
    background: color-mix(in srgb, var(--uc) 13%, transparent);
    border-color: color-mix(in srgb, var(--uc) 40%, transparent);
    transform: scale(1.04);
  }
 
  .uc-blue   { --uc: #2563EB; --uc2: #4F8EF7; --uc-bg: #EFF6FF; }
  .uc-orange { --uc: #EA580C; --uc2: #F97316; --uc-bg: #FFF7ED; }
  .uc-teal   { --uc: #0D9488; --uc2: #059669; --uc-bg: #F0FDFA; }
  .uc-violet { --uc: #7C3AED; --uc2: #A21CAF; --uc-bg: #F5F3FF; }
 
  .u-pills-row { display: flex; flex-direction: column; gap: 6px; margin-top: 8px; }
  .u-pill {
    display: inline-flex; align-items: center; gap: 6px;
    border-radius: 8px; padding: 5px 11px;
    font-size: 10px; font-weight: 700; width: fit-content;
  }
  .u-pill-dot { width: 5px; height: 5px; border-radius: 50%; flex-shrink: 0; }
  .u-pill-violet { background: #F5F3FF; border: 1px solid #DDD6FE; color: #7C3AED; }
  .u-pill-violet .u-pill-dot { background: #7C3AED; }
  .u-pill-teal   { background: #F0FDFA; border: 1px solid #99F6E4; color: #0D9488; }
  .u-pill-teal   .u-pill-dot { background: #0D9488; }
 
  .dash-status-bar {
    display: flex; align-items: center; justify-content: space-between;
    background: #FFFFFF; border: 1px solid #E8ECF4;
    border-radius: 10px; padding: 10px 18px;
    box-shadow: 0 1px 3px rgba(15,23,42,0.04);
  }
  .dash-status-left { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 600; color: #010408; }
  .dash-status-dot {
    width: 7px; height: 7px; border-radius: 50%; background: #059669;
    box-shadow: 0 0 0 2px rgba(5,150,105,0.2); animation: pulse-dot 2.5s infinite;
  }
  @keyframes pulse-dot {
    0%, 100% { box-shadow: 0 0 0 2px rgba(5,150,105,0.2); }
    50%       { box-shadow: 0 0 0 5px rgba(5,150,105,0.08); }
  }
  .dash-status-right { font-size: 11px; font-weight: 500; color: #010408; }
`;
 
const Dashboard = () => {
  const navigate = useNavigate();
  const [typedText, setTypedText] = useState('');
  const [counts, setCounts] = useState({
    myEnquiries:    null,
    myFollowups:    null,
    totalEnquiries: null,
    totalFollowups: null,
  });
  const [loading, setLoading] = useState(true);
 
  const loggedUser = (() => {
    try { return JSON.parse(localStorage.getItem('user_data') || '{}'); }
    catch { return {}; }
  })();
 
  const isAdmin  = Number(loggedUser?.role) === 1;
  const userId   = loggedUser?.userid;
  const userName = loggedUser?.username ?? (isAdmin ? 'Admin' : 'User');
 
  const fetchAll = async () => {
    setLoading(true);
    try {
      const [enquiriesRes, followupsRes] = await Promise.all([
        fetch(`${URL}/enquiries`).then(r => r.json()),
        fetch(`${URL}/followup-masters`).then(r => r.json()),
      ]);
 
      const allEnquiries = extractArray(enquiriesRes);
      const allFollowups = extractArray(followupsRes);
 
      const myEnquiries = allEnquiries.filter(
        e => String(e.fkEmployeeId) === String(userId)
      );
      const myFollowups = allFollowups.filter(
        f => String(f.assignTo) === String(userId)
      );
 
      setCounts({
        myEnquiries:    myEnquiries.length,
        myFollowups:    myFollowups.length,
        totalEnquiries: allEnquiries.length,
        totalFollowups: allFollowups.length,
      });
 
    } catch (e) {
      console.error('Dashboard fetch error:', e);
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => { fetchAll(); }, []);
 
  const now = new Date();
  const dateStr = now.toLocaleDateString('en-IN', {
    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
  });
 
  const mainEnqCount = isAdmin ? counts.totalEnquiries : counts.totalEnquiries;
  const mainFupCount = isAdmin ? counts.totalFollowups : counts.myFollowups;
 
  const CountDisplay = ({ val }) =>
    loading ? <span className="u-skeleton" /> : <>{val ?? '—'}</>;
 
  const pillVal = (val) => loading ? '...' : (val ?? '—');
 
  return (

    
<>

<style>{styles}</style>
<div className="dash-root">
<div className="dash-inner">
 
          {/* HEADER */}
<div className="dash-header">
<div className="dash-logo-wrap">
<img src={CRMLogo} alt="Logo" />
</div>
<div className="dash-header-text">
<div className="dash-header-eyebrow">
                {isAdmin ? 'Admin Panel' : 'User Panel'}
</div>
<div className="dash-header-greeting">{getGreeting()}, {userName}</div>
<div className="dash-header-sub">Varadvinayak Real Infra</div>
</div>
<div className="dash-header-meta">
<div className="dash-date-pill">{dateStr}</div>
<button
                className={`dash-refresh-btn${loading ? ' spinning' : ''}`}
                onClick={fetchAll}
                aria-label="Refresh data"
>
<RefreshIcon style={{ fontSize: 16 }} />
</button>
</div>
</div>
 
          {/* SECTION LABEL */}
<div className="dash-section-wrap">
<span className="dash-section-label">Overview</span>
<div className="dash-section-line" />
</div>
 
          {/* 4 CARDS */}
<div className="dash-4grid">
 
            {/* 1. New Enquiry */}
<div className="u-card uc-blue" onClick={() => navigate('/inquiry')}>
<div className="u-card-top">
<div className="u-icon-wrap">
<GroupsIcon style={{ fontSize: 24 }} />
</div>
<div className="u-badge"><div className="u-badge-dot" />Form</div>
</div>
<div className="u-count">
<CountDisplay val={mainEnqCount} />
</div>
<div className="u-label">New Enquiry</div>
<div className="u-desc">
                {isAdmin ? 'Total new customer enquiries received' : 'Total enquiries in the system'}
</div>
              {!isAdmin && (
<div className="u-my-pill u-my-pill-blue">
<div className="u-my-pill-dot" />
                  My Enquiries: {pillVal(counts.myEnquiries)}
</div>
              )}
<div className="u-divider" />
<div className="u-sub-row">
<button className="u-sub-btn"
                  onClick={e => { e.stopPropagation(); navigate('/inquiry'); }}>
<GroupsIcon style={{ fontSize: 12 }} /> Add New
</button>
</div>
</div>
 
            {/* 2. Enquiry List */}
<div className="u-card uc-orange" onClick={() => navigate('/inquiry-details')}>
<div className="u-card-top">
<div className="u-icon-wrap">
<PersonAddAlt1Icon style={{ fontSize: 24 }} />
</div>
<div className="u-badge"><div className="u-badge-dot" />List</div>
</div>
<div className="u-count">
<CountDisplay val={mainEnqCount} />
</div>
<div className="u-label">Enquiry List</div>
<div className="u-desc">
                {isAdmin ? 'All active enquiries in the pipeline' : 'Total enquiries in the system'}
</div>
              {!isAdmin && (
<div className="u-my-pill u-my-pill-orange">
<div className="u-my-pill-dot" />
                  My Enquiries: {pillVal(counts.myEnquiries)}
</div>
              )}
<div className="u-divider" />
<div className="u-sub-row">
<button className="u-sub-btn"
                  onClick={e => { e.stopPropagation(); navigate('/inquiry-details'); }}>
<PersonAddAlt1Icon style={{ fontSize: 12 }} /> View All
</button>
</div>
</div>
 
            {/* 3. Follow Up */}
<div className="u-card uc-teal" onClick={() => navigate('/leads')}>
<div className="u-card-top">
<div className="u-icon-wrap">
<PhoneCallbackIcon style={{ fontSize: 24 }} />
</div>
<div className="u-badge"><div className="u-badge-dot" />Tasks</div>
</div>
<div className="u-count">
<CountDisplay val={mainFupCount} />
</div>
<div className="u-label">Follow Up</div>
<div className="u-desc">
                {isAdmin ? 'Track callbacks, scheduled visits & reminders' : 'Followups assigned to you'}
</div>
<div className="u-divider" />
<div className="u-sub-row">
<button className="u-sub-btn"
                  onClick={e => { e.stopPropagation(); navigate('/leads'); }}>
<PhoneCallbackIcon style={{ fontSize: 12 }} /> Pending
</button>
<button className="u-sub-btn"
                  onClick={e => { e.stopPropagation(); navigate('/leads'); }}>
<EventNoteIcon style={{ fontSize: 12 }} /> Scheduled
</button>
</div>
</div>
 
            {/* 4. Reports */}
<div className="u-card uc-violet" onClick={() => navigate('/followup-report')}>
<div className="u-card-top">
<div className="u-icon-wrap">
<SummarizeIcon style={{ fontSize: 24 }} />
</div>
<div className="u-badge"><div className="u-badge-dot" />Analytics</div>
</div>
<div className="u-count">
<CountDisplay val={mainEnqCount} />
</div>
<div className="u-label">Reports</div>
<div className="u-desc">
                {isAdmin
                  ? 'Sales analytics, conversion funnel & insights'
                  : 'Performance insights for your enquiries'}
</div>
              {!isAdmin && (
<div className="u-pills-row">
<div className="u-pill u-pill-violet">
<div className="u-pill-dot" />
                    Total Enquiries: {pillVal(counts.totalEnquiries)}
</div>
<div className="u-pill u-pill-teal">
<div className="u-pill-dot" />
                    Total Followups: {pillVal(counts.totalFollowups)}
</div>
</div>
              )}
<div className="u-divider" />
<div className="u-sub-row">
<button className="u-sub-btn"
                  onClick={e => { e.stopPropagation(); navigate('/reports'); }}>
<SummarizeIcon style={{ fontSize: 12 }} /> Sales
</button>
<button className="u-sub-btn"
                  onClick={e => { e.stopPropagation(); navigate('/reports'); }}>
<InsightsIcon style={{ fontSize: 12 }} /> Analytics
</button>
</div>
</div>
 
          </div>
 
          {/* STATUS BAR */}
<div className="dash-status-bar">
<div className="dash-status-left">
<div className="dash-status-dot" />
<span>All systems operational</span>
</div>
<div className="dash-status-right">
              Last updated: {now.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
</div>
</div>
 
        </div>
</div>
</>
  );
};
 
export default Dashboard;